var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"tables"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Name")]),_c('b-col',{attrs:{"cols":"8"}},[_vm._v(_vm._s(_vm.modalData.name)+" ")]),_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Status")]),_c('b-col',{attrs:{"cols":"8"}},[_vm._v(_vm._s(_vm.modalData.status))])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }